import { render, staticRenderFns } from "./pageTargetSplit.vue?vue&type=template&id=240288ca&scoped=true"
import script from "./pageTargetSplit.vue?vue&type=script&lang=js"
export * from "./pageTargetSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240288ca",
  null
  
)

export default component.exports